import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class ColorSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'color');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        const colors = ['primary', 'secondary', 'success', 'info', 'notify', 'warning', 'danger'];
        return colors.map(color => this.colorComboField(`${color}.color`, {}));
    }

}
